module.exports = __webpack_public_path__ + "img/deletedSuccess.821d6364.svg";